import React from 'react';
import Styled from 'styled-components';
import {ColorUtils} from '../../utils';
import PropTypes from 'prop-types';
export const ProjectIndicatorStyle = Styled.a`
	box-sizing: border-box;
	display: flex;
	align-items: center;
	justify-content: center;
	overflow: hidden;
	outline:none;
	
	min-width: 46px;
	max-width: 46px;
	height: 20px;
	padding-left: 6px;
	padding-right: 6px;
	border-radius: 6px;

	background-color: #F2F2F2;
	color: ${ColorUtils.getInvertedTextColor('#F2F2F2')};
	font-size: 10px;
	font-weight: 700;
	text-decoration: none;
`;

const Container = Styled.div`
    display: flex;

	> *:not(:last-child) {
		margin-right: 8px;
	}
`;

export const ProjectIndicatorList = ({children, visibleCount = 3}) => {
	const childrenArray = React.Children.toArray(children);
	const showCounter = childrenArray.length > visibleCount;
	const visibleChildren = childrenArray.slice(0, showCounter ? visibleCount - 1 : visibleCount);
	const countNumber = childrenArray.length - visibleChildren.length;
	return (
		<Container>
			{visibleChildren.map(child => {
				return child;
			})}
			{showCounter && <ProjectIndicatorStyle>{`+${countNumber}`}</ProjectIndicatorStyle>}
		</Container>
	);
};

ProjectIndicatorList.propTypes = {
	children: PropTypes.node.isRequired,
	visibleCount: PropTypes.number,
};
